const tippySetup = (function () {
    const _settings = {
        playerScoresElement: document.querySelectorAll(".js-player-scores"),
        gameElement: document.querySelectorAll(".js-game-scores"),
    };

    let tippyInstances = [];

    function init() {
        tippy.setDefaultProps({ theme: "material" });
        startTippy();

        // Element with player scores have data attributes that allow retrieving of the player's stats
        if (_settings.playerScoresElement.length > 0) {
            setupPlayerScores();
        }

        // Element with teams have data attributes that allow retrieving of the games score
        if (_settings.gameElement.length > 0) {
            _setupGameScores();
        }
    }

    function startTippy() {
        // Destroy any existing tippy instances
        tippyInstances.forEach((instance) => instance.destroy());
        tippyInstances = [];

        // Helper to flatten NodeList/Array of tippy instances
        function addInstances(instances) {
            if (Array.isArray(instances)) {
                tippyInstances.push(...instances);
            } else if (instances && typeof instances === "object" && typeof instances.destroy === "function") {
                tippyInstances.push(instances);
            }
        }

        addInstances(
            tippy("[data-tippy-content]", {
                theme: "material",
                trigger: "mouseenter focusin",
                onShow(instance) {
                    const content =
                        typeof instance.props.content === "function"
                            ? instance.props.content(instance.reference)
                            : instance.props.content;
                    if (!content || !content.trim()) {
                        return false; // Prevent showing the tooltip if content is empty
                    }
                },
            })
        );
        addInstances(
            tippy("[data-tippy-content-menu]", {
                theme: "menu",
                allowHTML: true,
                trigger: "click",
                interactive: true,
                content: (reference) => reference.getAttribute("data-tippy-content-menu"),
                onShown(instance) {
                    document.querySelector("[data-tippy-root]").addEventListener("click", (event) => {
                        instance.hide();
                    });
                },
            })
        );
        addInstances(
            tippy("[data-tippy-content-light]", {
                theme: "light",
                content: (reference) => reference.getAttribute("data-tippy-content-light"),
            })
        );
        addInstances(
            tippy("[data-tippy-content-blue]", {
                theme: "blue",
                content: (reference) => reference.getAttribute("data-tippy-content-blue"),
            })
        );
        addInstances(
            tippy("[data-tippy-content-red]", {
                theme: "red",
                content: (reference) => reference.getAttribute("data-tippy-content-red"),
            })
        );
        addInstances(
            tippy("[data-tippy-content-left]", {
                theme: "material",
                placement: "left",
                content: (reference) => reference.getAttribute("data-tippy-content-left"),
            })
        );
        addInstances(
            tippy("[data-tippy-content-right]", {
                theme: "material",
                placement: "right",
                content: (reference) => reference.getAttribute("data-tippy-content-right"),
            })
        );
    }

    function setupPlayerScores() {
        const playerScoreElements = document.querySelectorAll(".js-player-scores");
        /**
         * Start by removing any existing Tippy instances on the elements. This is
         * necessary because we will be reinitializing the Tippy instances with new
         * options and we want to make sure that there are no lingering instances
         * that could interfere with the new ones.
         */

        // Loop through the elements and destroy their Tippy instances
        playerScoreElements.forEach((element) => {
            if (element._tippy) {
                element._tippy.destroy(); // Destroy the tooltip instance
            }
        });

        tippy(playerScoreElements, {
            allowHTML: true,
            trigger: "click",
            placement: "right",

            onCreate(instance) {
                // Setup our own custom state properties
                instance._isFetching = false;
                instance._src = null;
                instance._error = null;
            },
            onShow(instance) {
                if (instance._isFetching || instance._src || instance._error) {
                    return;
                }
                instance._isFetching = true;

                const pid = instance.reference.getAttribute("data-pid");
                const week = instance.reference.getAttribute("data-week");
                const year = instance.reference.getAttribute("data-year");
                const seasonType = instance.reference.getAttribute("data-season-type");

                const timeDelay = 250;
                const loadingTimeout = setTimeout(() => {
                    instance.setContent("Loading...");
                }, timeDelay);

                fetch(
                    "/xhr/stats_player_detail.php?pid=" +
                        pid +
                        "&stat_week=" +
                        week +
                        "&stat_year=" +
                        year +
                        "&stat_season_type=" +
                        seasonType
                )
                    .then((response) => response.text())
                    .then((text) => {
                        clearTimeout(loadingTimeout);
                        instance.setContent(text);
                    })
                    .catch((error) => {
                        clearTimeout(loadingTimeout);
                        instance._error = error;
                        instance.setContent("No stats");
                    })
                    .finally(() => {
                        instance._isFetching = false;
                    });
            },
            onHidden(instance) {
                // Unset these properties so new network requests can be initiated
                instance._src = null;
                instance._error = null;
            },
        });
    }

    function closeAll() {
        tippy.hideAll({ duration: 0 });
    }

    function _setupGameScores() {
        const gameScoreElements = document.querySelectorAll(".js-game-scores");

        /**
         * Start by removing any existing Tippy instances on the elements. This is
         * necessary because we will be reinitializing the Tippy instances with new
         * options and we want to make sure that there are no lingering instances
         * that could interfere with the new ones.
         */

        // Loop through the elements and destroy their Tippy instances
        gameScoreElements.forEach((element) => {
            if (element._tippy) {
                element._tippy.destroy(); // Destroy the tooltip instance
            }
        });

        tippy(gameScoreElements, {
            allowHTML: true,
            trigger: "click",
            placement: "right",

            onCreate(instance) {
                // Setup our own custom state properties
                instance._isFetching = false;
                instance._src = null;
                instance._error = null;
            },
            onShow(instance) {
                if (instance._isFetching || instance._src || instance._error) {
                    return;
                }

                instance._isFetching = true;
                const team = instance.reference.getAttribute("data-team");
                const week = instance.reference.getAttribute("data-week");
                const year = instance.reference.getAttribute("data-year");

                const timeDelay = 250;
                const loadingTimeout = setTimeout(() => {
                    instance.setContent("Loading...");
                }, timeDelay);

                fetch("/xhr/game_result.php?team=" + team + "&stat_week=" + week + "&stat_year=" + year)
                    .then((response) => response.text())
                    .then((text) => {
                        clearTimeout(loadingTimeout);
                        instance.setContent(text);
                    })
                    .catch((error) => {
                        clearTimeout(loadingTimeout);
                        instance._error = error;
                        instance.setContent("No game result");
                    })
                    .finally(() => {
                        instance._isFetching = false;
                    });
            },
            onHidden(instance) {
                // Unset these properties so new network requests can be initiated
                instance._src = null;
                instance._error = null;
            },
        });
    }

    return {
        init: init,
        startTippy: startTippy,
        setupPlayerScores: setupPlayerScores,
        closeAll: closeAll,
    };
})();

export { tippySetup };
